/* Copyright 2013 The MathWorks, Inc. */

/**
 * This is a list of components that should trigger the collapsing of their parent Toolstrip.
 * The key is the component type and the value is an object with an array of events and an array of properties that when
 * fired/changed, should collapse the parent Toolstrip.
 */

define([
    "../constants/TypeConstants"
], function (TypeConstants) {
    var hash = {};

    hash[TypeConstants.PUSH_BUTTON] = {
        events: ["buttonPushed"],
        properties: []
    };

    hash[TypeConstants.SPLIT_BUTTON] = {
        events: ["buttonPushed"],
        properties: []
    };

    hash[TypeConstants.TOGGLE_BUTTON] = {
        events: [],
        properties: ["checked"]
    };

    hash[TypeConstants.TOGGLE_SPLIT_BUTTON] = {
        events: [],
        properties: ["checked"]
    };

    hash[TypeConstants.LIST_ITEM] = {
        events: ["itemPushed"],
        properties: []
    };

    hash[TypeConstants.LIST_ITEM_WITH_CHECKBOX] = {
        events: ["closeRequest"],
        properties: []
    };

    hash[TypeConstants.COMBO_BOX] = {
        events: [],
        properties: ["value"]
    };

    hash[TypeConstants.CHECK_BOX] = {
        events: [],
        properties: ["checked"]
    };

    hash[TypeConstants.RADIO_BUTTON] = {
        events: [],
        properties: ["checked"]
    };

    hash[TypeConstants.SPLIT_BUTTON_WITH_DISABLE_OVERRIDE] = {
        events: ["buttonPushed"],
        properties: []
    };

    hash[TypeConstants.GALLERY_ITEM] = {
        events: ["itemPushed"],
        properties: []
    };

    hash[TypeConstants.TOGGLE_GALLERY_ITEM] = {
        events: [],
        properties: ["checked"]
    };

    hash[TypeConstants.QAB_PUSH_BUTTON] = {
        events: ["buttonPushed"],
        properties: []
    };

    hash[TypeConstants.QAB_SPLIT_BUTTON] = {
        events: ["buttonPushed"],
        properties: []
    };

    hash[TypeConstants.QAB_TOGGLE_BUTTON] = {
        events: [],
        properties: ["checked"]
    };

    hash[TypeConstants.QAB_TOGGLE_SPLIT_BUTTON] = {
        events: [],
        properties: ["checked"]
    };

    return hash;
});